import { Button } from "@/components/ui/button";
import { ChevronLeft, History, MoreVertical, RefreshCw, Trash2 } from "lucide-react";

interface AgentEditorHeaderProps {
  isEditing: boolean;
  isSaving: boolean;
  onBack: () => void;
  onDelete: () => void;
  onReset: () => void;
  onSave: () => void;
}

export const AgentEditorHeader = ({
  isEditing,
  isSaving,
  onBack,
  onDelete,
  onReset,
  onSave,
}: AgentEditorHeaderProps) => (
  <div className="px-6 py-4 border-b flex items-center justify-between">
    <div className="flex items-center gap-2">
      <Button
        variant="ghost"
        size="icon"
        onClick={onBack}
        className="text-muted-foreground"
      >
        <ChevronLeft className="h-4 w-4" />
      </Button>

      {isEditing && (
        <Button
          variant="ghost"
          size="icon"
          onClick={onDelete}
          className="text-muted-foreground hover:text-destructive"
        >
          <Trash2 className="h-4 w-4" />
        </Button>
      )}
    </div>

    <div className="flex items-center gap-2">
      {isEditing && (
        <Button
          variant="ghost"
          size="icon"
          onClick={onReset}
          className="text-muted-foreground"
        >
          <RefreshCw className="h-4 w-4" />
        </Button>
      )}

      <div className="text-xs text-muted-foreground mr-4">
        Built by Claire Labs
      </div>

      <Button
        className="bg-brand hover:bg-brand-600 text-white"
        onClick={onSave}
        disabled={isSaving}
      >
        {isSaving ? "Saving..." : "Save changes"}
      </Button>

      <Button variant="ghost" size="icon">
        <History className="h-4 w-4" />
      </Button>
      <Button variant="ghost" size="icon">
        <MoreVertical className="h-4 w-4" />
      </Button>
    </div>
  </div>
);
